import React from 'react';
import { Row, Col} from 'reactstrap';
import PropTypes from 'prop-types'

const RegistrationSuccess = ({clubName, minor}) => (
  <Row >
    <Col md={{ size: 10,offset: 1 }} className="formGroup TextCenter">
      <h2>
          Bedankt voor je aanmelding!
      </h2>
      <p hidden={minor}>
        De aanmelding bij {clubName} is succesvol verlopen.<br/>
        De ledenadministrateur zal je aanmelding verwerken.<br/>
        Als je vragen hebt kan je contact opnemen met de ledenadministratie van {clubName}.
      </p>
      <p hidden={!minor}>
        De aanmelding bij {clubName} is succesvol verlopen.<br/>
        Voordat de ledenadministrateur deze aanmelding verder kan verwerken is de bevestiging nodig van de ouder/verzorger.<br/>
        Het verzoek om deze aanmelding te bevestigen is verstuurd naar het e-mail adres van de ouder/verzorger.<br/>
        Als je vragen hebt kan je contact opnemen met de ledenadministratie van {clubName}.
      </p>
    </Col>
  </Row>
);

RegistrationSuccess.propTypes = {
  clubName: PropTypes.string,
  minor: PropTypes.bool,
}


export default RegistrationSuccess;



// WEBPACK FOOTER //
// ./src/registrationform/RegistrationSuccess.jsx